import { Box, IconButton, styled } from '@mui/material';
import { SIDE_NAV_WIDTH, SUB_NAV_WIDTH } from 'src/constants';

// Container keeps layout space in flex rows.
export const Wrapper = styled(Box)(
  () => `
    display: flex;
    flex-direction: column; 
    align-items: center;
    width: ${SUB_NAV_WIDTH}px;
    flex: 0 0 ${SUB_NAV_WIDTH}px;
    height: auto;
    align-self: stretch;
`,
);

// Fixed rail stays visible throughout scroll length.
export const FixedWrapper = styled(Box)(
  ({ theme }) => `
    position: fixed;
    top: 0;
    bottom: 0;
    left: ${SIDE_NAV_WIDTH}px;
    width: ${SUB_NAV_WIDTH}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${theme.palette.brand.whitesmoke};
    z-index: 1200;
  `,
);

export const Menu = styled('ul')`
  list-style: none;
  margin: 0;
  padding: 0;
  flex-grow: 1;
  flex-direction: column;

  overflow-y: auto;
  z-index: 1;
`;

export const MenuItem = styled('li')(
  ({ theme, $isSelected, $disabledHighlightIconColor }) => `
    height: 62px;
    width: 62px;
  
    display: flex;
    justify-content: center;
    align-items: center;
  
    svg {
      width: 24px;
      height: 24px;
      color: ${
        !$disabledHighlightIconColor && $isSelected
          ? theme.palette.primary.main
          : 'inherit'
      };
    }

    background-color: ${
      $isSelected ? theme.palette.background.default : 'unset'
    };
`,
);

export const MenuIcon = styled(IconButton)`
  border-radius: 0;
`;
